import ArrowUpRight from "Assets/Icons/ArrowUpRightIcon";
import styled from "styled-components";
import { ScheduleStatusColor } from "utilFunctions/shared/ScheduleStatus";
import FacultyStarIcon from "Assets/Icons/FacultyStarIcon";
import { useState } from "react";
import FeedbackViewModal from "Pages/Faculties/FeedbackViewModal";
import Typography from "Components/CommonComponents/Typography";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
const HeadingDiv: any = styled<any>("div")`
  font-weight: 700;
  font-size: 28px;
  color: #333333;
`;
const ScheduleStatuSpan: any = styled<any>("span")`
  color: ${({ color }: any) => color};
  font-size: 16px;
  font-weight: 600;
  width: 100%;
`;
const ScheduleStatuSpan2: any = styled<any>("span")`
  color: #828282;
  font-size: 16px;
  font-weight: 600;
  margin-left: 5px;
`;
const StyledCard: any = styled<any>("div")`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100%;
  width: 100% !important;
  background: #fff;
`;
const SessionHeaderRow: any = styled<any>("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
`;
const SessionSelect: any = styled<any>("select")`
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  color: #262626;
  background: #fff;
`;

const LectureCountCard = ({
  screen,
  totalUnmarkedLectures,
  batchCount,
  navigate,
  userInfo,
  facultyFeedbackData,
  setYearMonthForFeedback,
  dateFilterValues,
  facultyFeedbackHomeData,
  sessionsList,
  selectedSession,
  setSelectedSession,
}: any) => {
  const [isLectureViewModal, setIsLectureViewModal] = useState<any>(false);
  const handleOverallRatingClick = () => {
    pushToDataLayerForGTM({
      event: "ag_home_screen_dashboard_overall_rating_clicked",
      OVERALL_RATING: facultyFeedbackHomeData ?? "",
      USER_ROLE: userInfo?.fexRole || "",
      EMPLOYEE_ID: userInfo?.employeeId || "",
    });
    // navigate("/admin/faculties/" + userInfo?.id, {
    //   replace: true,
    //   state: {
    //     selectedStudent: userInfo?.id,
    //   },
    // });
    console.log("userInfo", userInfo);
    setIsLectureViewModal(!isLectureViewModal);
  };
  const handleUnmarkedLectureClick = () => {
    pushToDataLayerForGTM({
      event: "ag_home_screen_dashboard_unmarked_lecture_clicked",
      COUNT: totalUnmarkedLectures ?? 0,
      USER_ROLE: userInfo?.fexRole || "",
      EMPLOYEE_ID: userInfo?.employeeId || "",
    });

    navigate("/admin/schedule", {
      replace: false,
      state: {
        isNotMarkedVisible: true,
      },
    });
  };
  return (
    <>
      <SessionHeaderRow>
        <Typography
          variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
          color="darkgray"
        >
          Session Overview
        </Typography>
        <div className="d-flex align-items-center">
          <span style={{ marginRight: "8px", color: "#262626" }}>Session:</span>
          <SessionSelect
            value={selectedSession}
            onChange={(e: any) => setSelectedSession(e.target.value)}
            disabled={!sessionsList || sessionsList.length === 0}
          >
            {sessionsList && sessionsList.length > 0 ? (
              sessionsList.map((session: string) => (
                <option key={session} value={session}>
                  {session}
                </option>
              ))
            ) : (
              <option value="">No session found</option>
            )}
          </SessionSelect>
        </div>
      </SessionHeaderRow>
      <div
        className="d-flex flex-row w-100"
        style={{
          paddingBottom: "16px",
          height: "148px",
          width: "100% !important",
          gap: "16px",
          overflow: "auto",
        }}
      >
        <FeedbackViewModal
          mode="myBatchLecture"
          selectedlecture={null}
          isLectureViewModal={isLectureViewModal}
          setIsLectureViewModal={setIsLectureViewModal}
          setYearMonthForFeedback={setYearMonthForFeedback}
          dateFilterValues={dateFilterValues}
          facultyFeedbackData={facultyFeedbackData}
        ></FeedbackViewModal>
        <StyledCard
          className="headerContent"
          onClick={handleUnmarkedLectureClick}
        >
          <HeadingDiv totalUnmarkedLectures>
            {totalUnmarkedLectures > 0
              ? totalUnmarkedLectures
              : totalUnmarkedLectures + "🎉"}
          </HeadingDiv>
          <div style={{ whiteSpace: "nowrap" }}>
            <ScheduleStatuSpan
              color={
                totalUnmarkedLectures > 0
                  ? ScheduleStatusColor("Not Marked")
                  : "green"
              }
            >
              Unmarked
            </ScheduleStatuSpan>
            <ScheduleStatuSpan2>
              Lectures
              <ArrowUpRight className="cursorHoverCSS" />
            </ScheduleStatuSpan2>
          </div>
        </StyledCard>
        <StyledCard
          className="headerContent"
          onClick={() => {
            navigate("/admin/batches");
          }}
        >
          <HeadingDiv>{batchCount}</HeadingDiv>
          <div style={{ whiteSpace: "nowrap" }}>
            <ScheduleStatuSpan2>
              My Batches
              <ArrowUpRight className="cursorHoverCSS" />
            </ScheduleStatuSpan2>
          </div>
        </StyledCard>
        <StyledCard
          className="headerContent"
          onClick={handleOverallRatingClick}
        >
          <HeadingDiv>
            {<FacultyStarIcon />}{" "}
            {facultyFeedbackHomeData !== null ? facultyFeedbackHomeData : "NA"}
          </HeadingDiv>
          <div style={{ whiteSpace: "nowrap" }}>
            <ScheduleStatuSpan2>
              Overall Rating
              <ArrowUpRight className="cursorHoverCSS" />
            </ScheduleStatuSpan2>
          </div>
        </StyledCard>
      </div>
    </>
  );
};
export default LectureCountCard;
